import React from "react";
import { FadeIn } from "../FadeIn";
import { cn } from "~/lib/utils";
import { LogoLoadingSpinner } from "../LoadingSpinner";

// // // //

/**
 * Prevents the SwapCard from rendering until the VaultClient has been initialized
 */
export function LoadingBoundary(props: {
    loading: boolean;
    className?: string;
    children: React.ReactNode;
}) {
    const { loading, children, className } = props;

    return (
        <React.Fragment>
            {loading && (
                <div
                    className={cn(
                        "max-w-3xl mx-auto flex-1 overflow-y-auto p-5 flex items-center justify-center",
                        className,
                    )}
                >
                    <FadeIn show={loading}>
                        <div className="flex absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] flex-col gap-4 items-center justify-center select-none">
                            <LogoLoadingSpinner size={175} />
                        </div>
                    </FadeIn>
                </div>
            )}

            {!loading && <>{children}</>}
        </React.Fragment>
    );
}
